/**
 * Generates a pseudo-random, 6-character hexadecimal value.
 */

const generateRandomId = (): string =>
    Math.floor(Math.random() * 16777215)
        .toString(16)
        .toUpperCase();

export default generateRandomId;
